import { GeneralIcon } from "gatsby-interface"
import { orgSettings as text } from "@modules/locales/default.js"

export const OrgSettingsSection = {
  General: `general`,
  Plan: `plan`,
  Status: `status`,
  Details: `details`,
  Usage: `usage`,
  Addons: `addons`,
  PaymentMethod: `paymentMethod`,
  PaymentHistory: `paymentHistory`,
  SelfHostedGit: `selfHostedGit`,
  VCSHealth: `vcsHealth`,
}

export const OrgSettingsSectionLabel = {
  [OrgSettingsSection.General]: text.headers.general,
  [OrgSettingsSection.Plan]: text.headers.plan,
  [OrgSettingsSection.Status]: text.headers.status,
  [OrgSettingsSection.Details]: text.headers.details,
  [OrgSettingsSection.Usage]: text.headers.usage,
  [OrgSettingsSection.Addons]: text.headers.addons,
  [OrgSettingsSection.PaymentMethod]: text.headers.paymentMethod,
  [OrgSettingsSection.PaymentHistory]: text.headers.paymentHistory,
  [OrgSettingsSection.SelfHostedGit]: text.headers.selfHostedGit,
  [OrgSettingsSection.VCSHealth]: text.headers.vcsHealth,
}

export const orgSettings = function createOrgSettings({
  paymentIsDefined,
  hasOnPremGitConnection,
  workspaceSettingsVcsHealthCard,
}) {
  const subsections = [
    {
      id: OrgSettingsSection.Details,
    },
    {
      id: OrgSettingsSection.Plan,
    },
  ]

  subsections.push({
    id: OrgSettingsSection.Addons,
  })
  subsections.push({
    id: OrgSettingsSection.Usage,
  })

  if (paymentIsDefined) {
    subsections.push({
      id: OrgSettingsSection.PaymentMethod,
    })
    subsections.push({
      id: OrgSettingsSection.PaymentHistory,
    })
  }

  if (hasOnPremGitConnection) {
    subsections.push({
      id: OrgSettingsSection.SelfHostedGit,
    })
  }

  if (workspaceSettingsVcsHealthCard) {
    subsections.push({
      id: OrgSettingsSection.VCSHealth,
    })
  }

  return [
    {
      id: OrgSettingsSection.General,
      Icon: GeneralIcon,
      subsections: [
        ...subsections,
        {
          id: OrgSettingsSection.Status,
        },
      ],
    },
  ]
}

/**
 * An object of this shape:
 * {
 *   [sectionId: string]: string | null
 * }
 * which allows to easily lookup if there is a parent section for provided section
 */
export const orgSettingsParentSections = orgSettings(true).reduce(
  (memo, { id: sectionId, subsections }) => {
    const nextValue = {
      ...memo,
      [sectionId]: null,
    }

    if (!subsections || subsections.length === 0) {
      return nextValue
    }

    const subsectionsParents = subsections.reduce((memo, subsection) => ({
      [subsection.id]: sectionId,
    }))

    return {
      ...nextValue,
      ...subsectionsParents,
    }
  },
  {}
)
